import { type PrimeSitePropertiesQueryQuery } from "@generated/graphql";
import {
  useQuery,
  type UseQueryResult,
} from "@edreamsodigeo/frontend-api-client";

import { GET_PRIME_SITE_PROPERTIES } from "../operations/queries";

const usePrimeSitePropertiesQuery =
  (): UseQueryResult<PrimeSitePropertiesQueryQuery> => {
    return useQuery<PrimeSitePropertiesQueryQuery>(GET_PRIME_SITE_PROPERTIES);
  };

export default usePrimeSitePropertiesQuery;
